<div class="datetime-container">
  @if (this.currentFilter().sliderOptions?.enabled) {
    <mat-slide-toggle [(ngModel)]="sliderMode" (change)="modeChange($event)">
      {{ 'igo.geo.filter.sliderModeTitle' | translate }}
    </mat-slide-toggle>
  }

  @if (sliderMode()) {
    <div class="slider-container">
      <igo-ogc-filter-time-slider
        [begin]="resolveDate(beginValue)"
        [max]="
          this.restrictedToStep() ? this.maxDate : resolveDate(this.endValue)
        "
        [currentFilter]="currentFilter()"
        [datasource]="datasource()"
        (changeProperty)="changePropertyByPass($event)"
      />
    </div>
  } @else {
    <div>
      @if (calendarTypeYear) {
        <div class="datepicker-input-container">
          <!-- to emulate a year-picker, 2 input: first input to show user just year and second input hiden and bind
          with the datepicker  -->
          <div class="datepicker-input">
            <igo-datepicker
              [placeholder]="'igo.geo.timeFilter.startYear' | translate"
              [todayButtonLabel]="'igo.geo.timeFilter.today' | translate"
              [clearButtonLabel]="'igo.geo.timeFilter.clear' | translate"
              [datepickerFilter]="filterBeginFunction"
              [minDate]="handleDate(datasource().options.minDate)"
              [maxDate]="
                endValue && !restrictedToStep()
                  ? endValue
                  : handleDate(datasource().options.maxDate)
              "
              [disabled]="filterStateDisable"
              [startView]="calendarView()"
              [startAt]="beginValue"
              [value]="
                beginValue
                  ? beginValue
                  : handleDate(datasource().options.minDate)
              "
              [calendarType]="calendarType()"
              (valueChange)="yearSelected($event, 'begin')"
              #beginDatepicker
            />
          </div>
          <div class="datepicker-input">
            <igo-datepicker
              class="year-input"
              [placeholder]="'igo.geo.timeFilter.endYear' | translate"
              [todayButtonLabel]="'igo.geo.timeFilter.today' | translate"
              [clearButtonLabel]="'igo.geo.timeFilter.clear' | translate"
              [datepickerFilter]="filterBeginFunction"
              [minDate]="
                beginValue
                  ? beginValue
                  : handleDate(datasource().options.minDate)
              "
              [maxDate]="handleDate(datasource().options.maxDate)"
              [disabled]="filterStateDisable"
              [startView]="calendarView()"
              [startAt]="endValue"
              [value]="
                endValue ? endValue : handleDate(datasource().options.maxDate)
              "
              [calendarType]="calendarType()"
              (valueChange)="yearSelected($event, 'end')"
              #endDatepicker
            />
          </div>
          <div class="actions-container">
            <button
              class="reset-button"
              mat-icon-button
              color="primary"
              (click)="resetFilter()"
              [matTooltip]="'igo.geo.filter.resetFilters' | translate"
              [disabled]="filterStateDisable"
            >
              <mat-icon>{{ resetIcon }}</mat-icon>
            </button>
            <mat-slide-toggle
              class="toggle-filter-state"
              (change)="toggleFilterState()"
              [matTooltip]="'igo.geo.filter.toggleFilterState' | translate"
              tooltip-position="below"
              matTooltipShowDelay="500"
              [checked]="!filterStateDisable"
            />
          </div>
        </div>
      }
      @if (calendarType() !== 'year') {
        <div class="datepicker-input-container">
          <div class="datepicker-input">
            <igo-datepicker
              [placeholder]="'igo.geo.timeFilter.startDate' | translate"
              [todayButtonLabel]="
                (calendarType() === 'datetime'
                  ? 'igo.geo.timeFilter.now'
                  : 'igo.geo.timeFilter.today'
                ) | translate
              "
              [clearButtonLabel]="'igo.geo.timeFilter.clear' | translate"
              [datepickerFilter]="filterBeginFunction"
              [minDate]="handleDate(datasource().options.minDate)"
              [maxDate]="
                endValue && !restrictedToStep()
                  ? endValue
                  : handleDate(datasource().options.maxDate)
              "
              [disabled]="filterStateDisable"
              [startAt]="beginValue"
              [value]="
                beginValue
                  ? beginValue
                  : handleDate(datasource().options.minDate)
              "
              [startView]="calendarView()"
              [calendarType]="calendarType()"
              (valueChange)="
                calendarType() === 'month'
                  ? monthSelected($event, 'begin')
                  : changeTemporalProperty($event, 1)
              "
              #beginDatepicker
            />
            @if (
              calendarType() === 'datetime' &&
              dateNotTimeFrame(beginValue, datasource().options.minDate)
            ) {
              <igo-timepicker
                [hourInputLabel]="'igo.geo.timeFilter.hour' | translate"
                [minuteInputLabel]="'igo.geo.timeFilter.minute' | translate"
                [disabled]="filterStateDisable"
                [value]="
                  beginValue
                    ? beginValue
                    : handleDate(datasource().options.minDate)
                "
                (valueChange)="updateTime($event, 1)"
                #beginTimepicker
                [interval]="stepMilliseconds / 60000"
                [maxHour]="
                  sameDate() ? resolveDate(endValue)?.getHours() : undefined
                "
              />
            }
          </div>
          @if (!restrictedToStep()) {
            <div class="datepicker-input">
              <igo-datepicker
                [placeholder]="'igo.geo.timeFilter.endDate' | translate"
                [todayButtonLabel]="
                  (calendarType() === 'datetime'
                    ? 'igo.geo.timeFilter.now'
                    : 'igo.geo.timeFilter.today'
                  ) | translate
                "
                [clearButtonLabel]="'igo.geo.timeFilter.clear' | translate"
                [datepickerFilter]="filterEndFunction"
                [minDate]="
                  beginValue
                    ? beginValue
                    : handleDate(datasource().options.minDate)
                "
                [maxDate]="handleDate(datasource().options.maxDate)"
                [disabled]="filterStateDisable"
                [startAt]="endValue"
                [value]="
                  endValue ? endValue : handleDate(datasource().options.maxDate)
                "
                [startView]="calendarView()"
                [calendarType]="calendarType()"
                (valueChange)="
                  calendarType() === 'month'
                    ? monthSelected($event, 'end')
                    : changeTemporalProperty($event, 2)
                "
                #endDatepicker
              />
              @if (
                calendarType() === 'datetime' &&
                dateNotTimeFrame(endValue, datasource().options.maxDate)
              ) {
                <igo-timepicker
                  [hourInputLabel]="'igo.geo.timeFilter.hour' | translate"
                  [minuteInputLabel]="'igo.geo.timeFilter.minute' | translate"
                  [disabled]="filterStateDisable"
                  [value]="
                    endValue
                      ? endValue
                      : handleDate(datasource().options.maxDate)
                  "
                  (valueChange)="updateTime($event, 2)"
                  [interval]="stepMilliseconds / 60000"
                  [minHour]="
                    sameDate() ? resolveDate(beginValue)?.getHours() : undefined
                  "
                  #endTimepicker
                />
              }
            </div>
          }
          <div class="actions-container">
            <button
              class="reset-button"
              mat-icon-button
              color="primary"
              (click)="resetFilter()"
              [matTooltip]="'igo.geo.filter.resetFilters' | translate"
              [disabled]="filterStateDisable"
            >
              <mat-icon>{{ resetIcon }}</mat-icon>
            </button>
            <mat-slide-toggle
              class="toggle-filter-state"
              (change)="toggleFilterState()"
              tooltip-position="below"
              matTooltipShowDelay="500"
              [matTooltip]="'igo.geo.filter.toggleFilterState' | translate"
              [checked]="!filterStateDisable"
            />
          </div>
        </div>
      }
    </div>
  }
</div>
